import gql from 'graphql-tag'

export const FINMA_REPORTS_GENERATE_QUERY = gql`
    query finmaReportsGenerate(
        $consultingCompanyIds: [ID!]!
        $dateFrom: Date!
        $dateUntil: Date!
    ) {
        finmaReportsGenerate(
            consulting_company_ids: $consultingCompanyIds
            date_from: $dateFrom
            date_until: $dateUntil
        ) {
            status
        }
    }
`
